module.exports = __webpack_public_path__ + "img/logo_lw.72b8c224.png";